export default {
    Locker: 'd5e3af71-ab56-44c4-bf4d-de7b53e47f38',
    L60: '415f008a-2913-49ea-9c62-e830f2c07008',
    Cool: 'fdfe7cf1-d266-4e1a-b26d-87423ce2b56b',
    HD36:'68534189-6ac4-4fdb-ae16-374d7870fd92',
    M22: 'eb5e33fc-b744-46fb-9ee6-802c602977c1',
    M24:'9fa0079a-3d98-4942-88c8-3f6537d68e48',
    FASTLANE: 'e9da3c38-b838-4054-8b74-dcfb7d2713d8',
    FASTLANEGOLIATH: '9e191ffe-2d0e-4609-8fac-e24e5e484cb8',
    C30: '3c5cd3cd-bf63-4662-81da-a1d68e2e0fcf',
    A12: '6d17b7f1-d107-4d27-af31-c10beed40827',
    V12: '149bf48b-39ff-4c7b-9cc8-df9f24ef871d',
    COOL_12: 'c9d0fc90-383d-4e1d-a52c-e98ff42b86cb',
    M41: '4eb90d79-d6fc-4b04-ba06-7b60feb26a61',
    C28: '1c4f111d-722a-4896-952b-31f9119b28a6',
    HD33: '33318078-e5e6-4e11-9dcf-f6ac9145a4be'
  };



// WEBPACK FOOTER //
// ./src/components/enum/box_type.js